const React = require("react")
const Layout = require("./src/components/layout")

// Contrôler le comportement de scroll lors de la navigation
exports.shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
    // Toujours remettre le scroll en haut lors de la navigation
    // Retourner [0, 0] force le scroll en haut de la page
    return;// [0, 0];
}

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
    // S'assurer que le scroll reste en haut après le rendu
    // if (typeof window !== 'undefined') {
    //     // Utiliser requestAnimationFrame pour s'assurer que le scroll se fait après le rendu
    //     requestAnimationFrame(() => {
    //         window.scrollTo(0, 0);
    //         // Double vérification avec un petit délai pour gérer les cas où le DOM n'est pas encore prêt
    //         setTimeout(() => {
    //             window.scrollTo(0, 0);
    //         }, 0);
    //     });
    // }

    const data = window.dataLayer

    if (typeof data === `object`) {
        const eventName = `gatsbyRouteChange`
        data.push({ event: eventName })

        pushUTMToDataLayer();
    }
}

const pushUTMToDataLayer = () => {
    // Récupérer les UTM depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
        utm_campaign: urlParams.get("utm_campaign"),
        utm_term: urlParams.get("utm_term"),
        gad_source: urlParams.get("gad_source"),
    };

    // Vérifier si des UTM sont présents dans l'URL
    const hasUTM = Object.values(utmParams).some((val) => val !== null);

    if (hasUTM) {
        // Pousser dans le dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "utm_params_received",
            utm_params: utmParams,
        });
    }
};


